module.exports = __webpack_public_path__ + "img/tornado.7cc54223.svg";